//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Notas from "@/api/promotores/usuarios/notas.api";
export default {
  props: {
    promotor: String,
  },
  data() {
    return {
      loading: false,
      nota: {
        contenido: "",
      },
    };
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    async submit() {
      try {
        this.loading = true;
        const response = await Notas.create(this.promotor, this.nota.contenido);
        this.$emit("ok", response);
        this.hide();
      } finally {
        this.loading = false;
      }
    },
  },
};
